module.exports = {
      id: "close-usage",
      viewBox: "0 0 512.001 512.001",
      url: __webpack_public_path__ + "svg-sprite-0a04d67e7be2467ff8c30ec762f261a0.svg#close",
      toString: function () {
        return this.url;
      }
    }